import Grid from "@mui/joy/Grid";
import Stack from "@mui/joy/Stack";
import { UseFormSetError, UseFormSetValue } from "react-hook-form";
import { PROVINCES } from "@/types/constants/common";
import Input from "@/components/FormComponents/Input";
import Select from "@/components/FormComponents/Select";
import Checkbox from "@/components/FormComponents/Checkbox";

interface Props {
  mode: "update" | "create";
  type: "agent" | "agency";
  register: any;
  control: any;
  setValue: UseFormSetValue<any>;
  setError: UseFormSetError<any>;
  errors: any;
  disable: boolean;
}

const AgentAgencyForm = ({ mode, type, errors, control, register, disable }: Props) => {
  return (
    <Stack direction={"row"} gap={4}>
      <Grid
        container
        rowSpacing={4}
        columnSpacing={4}
        sx={{
          flex: "5 5 0%",
        }}
      >
        {(type === "agent" || mode === "create") && (
          <>
            <Grid xs={3}>
              <Input
                name="firstname"
                required
                register={register}
                type="text"
                disabled={disable}
                error={errors.firstname?.message}
                label="First Name"
                placeholder="John"
              />
            </Grid>
            <Grid xs={3}>
              <Input
                name="lastname"
                required
                register={register}
                type="text"
                error={errors.lastname?.message ?? ""}
                disabled={disable}
                label="Last Name"
                placeholder="Doe"
              />
            </Grid>
          </>
        )}
        <Grid xs={3}>
          <Input
            name="streetAddress"
            required
            register={register}
            type="text"
            error={errors.streetAddress?.message ?? ""}
            disabled={disable}
            label="Street Address"
            placeholder="123 Placeholder Street"
          />
        </Grid>
        <Grid xs={3}>
          <Input
            name="city"
            required
            register={register}
            type="text"
            error={errors.city?.message}
            disabled={disable}
            label="City"
            placeholder="Toronto"
          />
        </Grid>

        <Grid xs={3}>
          <Select
            name={"province"}
            required
            label="Province"
            control={control}
            disabled={disable}
            error={errors.province?.message}
            items={PROVINCES}
            placeholder="Select Province"
          />
        </Grid>
        <Grid xs={3}>
          <Input
            name="postalCode"
            required
            register={register}
            type="text"
            error={errors.postalCode?.message}
            disabled={disable}
            label="Postal Code"
            placeholder="M5V3L9"
          />
        </Grid>

        <Grid xs={3}>
          <Input
            name="ttandEmail"
            required
            register={register}
            type="email"
            error={errors.ttandEmail?.message}
            disabled={disable}
            label="TTAND Email"
            placeholder="jdoe@thetravelagentnextdoor.com"
          />
        </Grid>
        <Grid xs={3}>
          <Input
            name="businessPhone"
            required
            register={register}
            type="text"
            error={errors.businessPhone?.message}
            disabled={disable}
            label="Business Phone"
            placeholder="4165551234"
          />
        </Grid>

        <Grid xs={3}>
          <Input
            name="brandedAs"
            required
            register={register}
            type="text"
            disabled={disable}
            error={errors.brandedAs?.message}
            label="Brand Name"
            placeholder="My Travel Agency"
          />
        </Grid>

        {!(type === "agency" && mode === "update") ? (
          <Grid xs={3}>
            <Input
              name="agentId"
              required
              register={register}
              type="text"
              error={errors.agentId?.message}
              disabled={disable}
              label="CRM Agent ID (Clientlinq)"
              placeholder="1234"
            />
          </Grid>
        ) : (
          <></>
        )}

        <Grid xs={3}>
          <Input
            name="clientlinqBranch"
            required
            register={register}
            type="text"
            disabled={disable}
            error={errors.clientlinqBranch?.message}
            label="CRM Branch No. (Clientlinq)"
            placeholder="123"
          />
        </Grid>

        {mode == "update" && type === "agent" && (
          <Grid xs={3}>
            <Select
              label="Select Agent Type"
              required
              placeholder="Agent Type"
              name={"agentType"}
              error={errors.agentType?.message}
              disabled={disable}
              control={control}
              items={[
                { value: "OWNER", label: "Owner" },
                { value: "HQSTAFF", label: "HQ Staff" },
                { value: "AGENT", label: "Agent" },
              ]}
            />
          </Grid>
        )}
        {mode === "update" && (
          <Grid xs={3}>
            <Checkbox
              name={"status"}
              error={errors.status?.message}
              control={control}
              disabled={disable}
              label={`Activate ${type === "agency" ? "Agency" : "Agent"}`}
              helperText={`Check to activate ${type}. Uncheck to deactivate.`}
            />
          </Grid>
        )}
      </Grid>
    </Stack>
  );
};

export default AgentAgencyForm;
